// Handle Advanced Custom Field's (WordPress Plugin) link field type.

import React from "react";
import Link from "./link";

const CmsLink = ({ link, arrow, whiteBtn, children, ...other }) => {
  if (link === null) return "";
  let finalUrl = link.url;

  if (!link.url.includes(".pdf")) {
    finalUrl = finalUrl.includes(process.env.WP_URL)
      ? finalUrl.replace(process.env.WP_URL, "")
      : finalUrl;
  } else {
    finalUrl = finalUrl.includes(process.env.GATSBY_URL)
      ? finalUrl.replace(process.env.GATSBY_URL, "")
      : finalUrl;
    finalUrl = finalUrl.includes(process.env.WP_URL)
      ? finalUrl
      : process.env.WP_URL + finalUrl;
  }

  if (link.target && !other["target"]) other["target"] = link.target;
  return (
    <Link to={finalUrl} {...other}>
      {children ? children : link.title}
      {whiteBtn && (
        <svg
          width="21"
          height="16"
          viewBox="0 0 21 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.4717 7.45875C20.8623 7.84928 20.8623 8.48244 20.4717 8.87296L14.1077 15.2369C13.7172 15.6274 13.0841 15.6274 12.6935 15.2369C12.303 14.8464 12.303 14.2132 12.6935 13.8227L17.3504 9.16584L-0.000488281 9.16576L-0.00047855 7.16576L17.3504 7.16584L12.6936 2.50897C12.3031 2.11844 12.3031 1.48527 12.6936 1.09475C13.0841 0.704232 13.7173 0.704235 14.1078 1.09476L20.4717 7.45875Z"
            fill="#00A950"
          />
        </svg>
      )}
    </Link>
  );
};

export default CmsLink;
